var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWaiter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_15771_22359_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -0.0645 -0.0645 0 65 65)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1012.32,
    y: -1012.32,
    width: 2024.65,
    height: 2024.65
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(200, 19, 27, 1) 0deg,rgba(200, 19, 27, 1) 63.243deg,rgba(200, 19, 27, 0) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 65C129.5 29.3776 100.622 0.5 65 0.5C29.3776 0.5 0.5 29.3776 0.5 65C0.5 100.622 29.3776 129.5 65 129.5C100.622 129.5 129.5 100.622 129.5 65ZM19.7872 65C19.7872 40.0297 40.0297 19.7872 65 19.7872C89.9703 19.7872 110.213 40.0297 110.213 65C110.213 89.9703 89.9703 110.213 65 110.213C40.0297 110.213 19.7872 89.9703 19.7872 65Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.78431373834609985,\"g\":0.074509806931018829,\"b\":0.10588235408067703,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.78431373834609985,\"g\":0.074509806931018829,\"b\":0.10588235408067703,\"a\":1.0},\"position\":0.17567500472068787},{\"color\":{\"r\":0.78431373834609985,\"g\":0.074509806931018829,\"b\":0.10588235408067703,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.78431373834609985,\"g\":0.074509806931018829,\"b\":0.10588235408067703,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.78431373834609985,\"g\":0.074509806931018829,\"b\":0.10588235408067703,\"a\":1.0},\"position\":0.17567500472068787},{\"color\":{\"r\":0.78431373834609985,\"g\":0.074509806931018829,\"b\":0.10588235408067703,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":7.8989718683020876e-15,\"m01\":-129.0,\"m02\":129.50,\"m10\":-129.0,\"m11\":-7.8989718683020876e-15,\"m12\":129.50},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_15771_22359_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.5 65C129.5 29.3776 100.622 0.5 65 0.5C29.3776 0.5 0.5 29.3776 0.5 65C0.5 100.622 29.3776 129.5 65 129.5C100.622 129.5 129.5 100.622 129.5 65ZM19.7872 65C19.7872 40.0297 40.0297 19.7872 65 19.7872C89.9703 19.7872 110.213 40.0297 110.213 65C110.213 89.9703 89.9703 110.213 65 110.213C40.0297 110.213 19.7872 89.9703 19.7872 65Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaiter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/waiter.25493100.svg";
export { ForwardRef as ReactComponent };